import { OnInit, Input, Component, Inject, Optional } from '@angular/core';
import { IContextService } from '@pershing/pershing-core';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { PershingTranslationService } from '@pershing/pershing-core';
import { DomSanitizer } from '@angular/platform-browser';
import { NxiContextUtils } from '@pershing/nxi-common';
import { DomainContext } from '@pershing/pershing-core';

@Component({
    selector: 'ssoout-generic-component',
    template: ''
})

export class SSOOutGenericComponent implements OnInit {
    @Input() pageName: string;
    appSettings: any;
    challengeURL: string;
    timeStamp: string;
    signedValue: string;
    userRefNum: string;
    acctRef: any;
    inputValue: any;
    launchURL: string;
    isMacLike: boolean;
    isIOS: boolean;
    IOSMessage: boolean;
    partnerID: string;
    width: string;
    height: string;
    frameBorder: string;
    isTRP: boolean = false;
    constructor(private contextService: IContextService,
                private nxiRestService: NxiRestService,
                private location: Location,
                private translationService: PershingTranslationService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                private route: ActivatedRoute,
                @Optional() @Inject('AppSettings') appSettings: any,
                private sanitizer: DomSanitizer) {
        this.appSettings = appSettings;
        if (appSettings.ibdConfigMap.IBD && appSettings.ibdConfigMap.IBD === '30A') {
            this.isTRP = true;
        }
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        // Call the wiget params service to get the valid args
        this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.widgetsParamService();
        });
    }

    widgetsParamService() {
        this.nxiWidgetParamsService.getWidgetParam('/commonrest/ssoout?url=' + this.pageName).subscribe(
            resp => {
                if (resp.response) {
                    this.partnerID = resp.response.partnerID;
                    this.width = resp.response.width;
                    this.height = resp.response.height;
                    this.frameBorder = resp.response.frameBorder;
                    this.launchURL = this.nxiRestService.serviceUrl + '/sso/websso';
                    if (!this.isTRP) {
                        this.openNewWindow();
                    } else {
                        this.openNewloaction();
                    }
                }
            }
        );
    }

    openNewWindow() {
        if (this.inputValue) {
            window.open(this.launchURL + '?SSOIndicator=' + this.partnerID + '&&acctId=' + this.inputValue, '_blank', 'name=SSOOUT class=noScroll width=' +
                this.width + ' height=' + this.height + ' frameborder=' + this.frameBorder);
        } else {
            window.open(this.launchURL + '?SSOIndicator=' + this.partnerID, '_blank', 'name=SSOOUT class=noScroll width=' +
                this.width + ' height=' + this.height + ' frameborder=' + this.frameBorder);
        }
    }
    openNewloaction() {
            window.location.href = this.launchURL + '?SSOIndicator=' + this.partnerID;
    }
}
